<table tuiTable size="l" style="width: 100%;" [columns]="columns">
  <thead>
    <tr tuiThGroup>
      <th class="th-style" *tuiHead="'date'" tuiTh [sticky]="true">
        {{ "sweeper_car.sweeper-car-node-detail.node-event.column.date" | translate }}
      </th>

      <th *tuiHead="'hour'" tuiTh [sticky]="true">
        {{ "sweeper_car.sweeper-car-node-detail.node-event.column.time" | translate }}
      </th>

      <th *tuiHead="'user'" tuiTh [sticky]="true">
        {{ "sweeper_car.sweeper-car-node-detail.node-event.column.user" | translate }}
      </th>

      <th *tuiHead="'event'" tuiTh [sticky]="true">
        {{ "sweeper_car.sweeper-car-node-detail.node-event.column.description" | translate }}
      </th>
    </tr>
  </thead>

  <tbody tuiTbody>
    <tr tuiTr *ngFor="let eve of events">
      <td *tuiCell="'date'" tuiTd>
        <div [tuiCell]="size">
          <span tuiTitle>
            {{ getDate(eve) }}
          </span>
        </div>
      </td>

      <td *tuiCell="'hour'" tuiTd>
        <div [tuiCell]="size">
          <span tuiTitle>
            {{ getDateHour(eve) }}
          </span>
        </div>
      </td>

      <td *tuiCell="'user'" tuiTd>
        <div [tuiCell]="size">
          <span tuiTitle>
            {{ getEventUser(eve) }}
          </span>
        </div>
      </td>

      <td *tuiCell="'event'" tuiTd>
        <div [tuiCell]="size">
          <span tuiTitle>
            {{ getEventDescription(eve) }}
          </span>
        </div>
      </td>
    </tr>
  </tbody>
</table>